import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

const looksLikeJwt = (key) => typeof key === 'string' && key.startsWith('eyJ');

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    'Missing REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY.'
  );
} else if (!looksLikeJwt(supabaseAnonKey)) {
  console.warn(
    'REACT_APP_SUPABASE_ANON_KEY should be the legacy "anon public" JWT from Supabase Dashboard → Settings → API (starts with eyJ). Publishable keys may not work with this client yet.'
  );
}

export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder-key',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  }
);

export async function verifyAdminUser(userId) {
  const { data, error } = await supabase
    .from('admins')
    .select('id')
    .eq('id', userId)
    .maybeSingle();

  if (error) throw error;
  return !!data;
}
